import env from '@y2/environments';
import texts from './breadcrumbs.texts.json';
const BASE_URL = env.routes.mainSite;

export const MAIN_BREADCRUMB = {
  title: texts.main,
  href: BASE_URL,
};
